export class RFIDCardProtocolEntry {

  usageTimestamp: string;
  usageLocation: string;
  rfidCardNumber: string;
  rfidCardDescription: string;
  accessAllowed = false;

  constructor(entry: any) {
    this.usageTimestamp = entry.usageTimestamp;
    this.usageLocation = entry.usageLocation;
    this.rfidCardNumber = entry.rfidCardNumber;
    this.rfidCardDescription = entry.rfidCardDescription;
    this.accessAllowed = entry.accessAllowed === true;
  }
}

export class RFIDCardProtocol {

  protocolEntries = new Array<RFIDCardProtocolEntry>();

  constructor(protocol: any) {
    if (protocol.protocolEntries != null) {
      for (const entry of protocol.protocolEntries) {
        this.protocolEntries.push(new RFIDCardProtocolEntry(entry));
      }
    }
  }
}
